import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

interface RadioProps {
  value: boolean;
  onChange?: (checked: boolean) => void;
  style?: React.CSSProperties;
  className?: string;
}

function Radio({
  style,
  className,
  value,
  onChange,
}: RadioProps) {
  return (
    <div
      className={classNames(className, styles.Radio, { [styles.selected]: value })}
      style={style}
      onClick={() => {
        onChange?.(!value);
      }}
    >
      <div className={styles.circle} />
    </div>
  );
}

export default Radio;
